import { useSearchParams } from 'react-router-dom'

import { isEnumValue } from 'modules/core/lib/utils/enums'

type FromEnum = 'evaluation-completion'

const FromEnumValues: FromEnum[] = ['evaluation-completion']

export const useFlow = () => {
  const [searchParams] = useSearchParams()

  const fromParams = searchParams.get('from')
  return { from: fromParams && isEnumValue(FromEnumValues, fromParams) ? fromParams : undefined }
}
